import { http } from "./http";

/**
 * Public voicemail page (/vm/<guid>). No session: the unguessable guid from
 * the notification mail is the only credential (see VoicemailController).
 */

export interface VoicemailDto {
  key: string;
  calledNumber: string;
  calledName: string;
  callingNumber: string;
  receivedUtc: string;
  /** Customer time zone the mail showed (Windows id, "UTC" when none) and the IANA equivalent for Intl. */
  timeZone: string;
  timeZoneIana: string;
  lengthMs: number | null;
  filename: string;
  /** The mp3 has reached the recordings server (the upload may lag the mail by a few seconds). */
  audioAvailable: boolean;
  transcript: string | null;
  transcriptLanguage: string | null;
  transcribedUtc: string | null;
  playCount: number;
}

export interface TranscriptDto {
  transcript: string;
  language: string | null;
  confidence: number | null;
  transcribedUtc: string;
}

const base = "/api/vm";

export const voicemailApi = {
  get: (key: string) => http<VoicemailDto>(`${base}/${encodeURIComponent(key)}`),
  /** Same-origin audio URL for the player; `download` sends it as an attachment. */
  audioUrl: (key: string, download = false) =>
    `${base}/${encodeURIComponent(key)}/audio${download ? "?download=true" : ""}`,
  transcribe: (key: string, language: string | null, force = false) =>
    http<TranscriptDto>(`${base}/${encodeURIComponent(key)}/transcribe${force ? "?force=true" : ""}`, {
      method: "POST",
      body: JSON.stringify({ language }),
    }),
};
